import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {UserService} from "../service/user.service";
import {EmailVerificationService} from "../service/email-verification.service";
import {EMAIL_PATTERN} from "../constants/validation.constants";
import {MESSAGE_TIMEOUT} from "../constants/global.constants";
import {AuthenticationResponse} from "../interface/authenticationResponse";
import {UserRole} from "../enums/UserRole";
import {HttpErrorResponse} from "@angular/common/http";
import {TokenUtil} from "../utilityClass/tokenUtil";

@Component({
  selector: 'app-admin-login-page',
  templateUrl: './admin-login-page.component.html',
  styleUrls: ['./admin-login-page.component.scss','../shared/scss/login.scss']
})
export class AdminLoginPageComponent implements OnInit{
    form: FormGroup;
    showPassword: boolean = false;
    loginError: boolean = false;
    unregisteredMail: boolean = false;
    notVerifiedMessage: boolean = false;
    verifiedMessage: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private router: Router,
    private emailVerificationService: EmailVerificationService,
    private tokenUtil: TokenUtil
  ) {
    this.form = this.createLoginForm();
  }

    createLoginForm(): FormGroup {
        return this.formBuilder.group({
            email: ['', [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
            password: ['', [Validators.required]],
        }, {updateOn: 'blur'});
    }

    ngOnInit(): void {
        const adminToken = this.userService.adminToken;
        if (adminToken) {
            this.userService.setAdminRole(UserRole.ADMIN, this.tokenUtil.getJwtTokenExpirationTimestamp(adminToken));
            this.router.navigate(['/admin/page/links']);
        }
        this.emailVerificationService.emailVerified.subscribe(isVerified => {
            this.verifiedMessage = isVerified;
            setTimeout(() => {
                this.verifiedMessage = false;
            }, MESSAGE_TIMEOUT);
        });
    }

    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    login() {
        this.form.markAllAsTouched();
        if (this.form.invalid) {
            return;
        }

        const user = {
            email: this.form.value.email,
            password: this.form.value.password,
            returnSecureToken: true
        };

        this.userService.login(user).subscribe((response: AuthenticationResponse) => {
          this.handleLoginResponse(response);
        }, (error: HttpErrorResponse) => {
            this.handleLoginError(error)
        })
    }

  handleLoginError(error: HttpErrorResponse) {
    if (error.status === 401) {
      this.loginError = true;
      this.unregisteredMail = false;
    } else if (error.status === 404) {
      this.unregisteredMail = true;
    } else if (error.status === 403) {
      this.notVerifiedMessage = true;
      this.form.reset();
      setTimeout(() => {
        this.notVerifiedMessage = false;
      }, MESSAGE_TIMEOUT);
    } else {
      console.error('Login error:', error);
    }
  }

  handleLoginResponse(response: AuthenticationResponse) {
    if (response.role === UserRole.ADMIN) {
      const token = response.token;
      const email = response.email;
      const role = response.role;
      const expirationDate = this.tokenUtil.getJwtTokenExpirationTimestamp(token);

      this.userService.setAdminToken(token, expirationDate);
      this.userService.setAdminEmail(email, expirationDate);
      this.userService.setAdminRole(role, expirationDate);

      this.router.navigate(['/admin/page/links']);
    } else {
      this.loginError = true;
    }
  }

    get loginFormControl() {
        return this.form.controls;
    }

    resetErrorMessage() {
        this.loginError = false;
        this.unregisteredMail = false;
    }
}
